<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reform',title:'改制单列表'},{title:'改制审批'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>研发样机</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                      <!--      <el-form-item label="改制需求号" class="h-elformWrap-2" prop="reformId">
                                                <el-input v-model="f.reformId" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>-->

                                          <!--  <el-form-item label="区域" class="h-elformWrap-2" prop="areaName">
                                                <el-input v-model="f.areaName" placeholder="请输入" >
                                                </el-input>
                                            </el-form-item>-->
                                            <el-form-item class="h-elformWrap-2" label="改制类型" prop="reformType">
                                                <el-select filterable  v-model="f.reformType" @change="changeReformType" placeholder="请选择">
                                                    <el-option value="0" label="研发样机"></el-option>
                                                   <!-- <el-option value="1" label="返修改制"></el-option>-->
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="h-elformWrap-2" label="返修类型" prop="fxType" v-if="this.isFx">
                                                <el-select filterable  v-model="f.fxType" @change="changeFxType" placeholder="请选择">
                                                    <el-option value="1" label="市场不良"></el-option>
                                                    <el-option value="2" label="经销商库存"></el-option>
                                                    <el-option value="3" label="EMR返修"></el-option>
                                                    <el-option value="4" label="质量封库"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input v-model="f.materialCode" placeholder="请输入" readonly>
                                                    <i class="el-icon-search el-input__icon"
                                                       slot="suffix"
                                                       @click="selectListByCode">
                                                    </i>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="数量" class="h-elformWrap-2" prop="number">
                                                <el-input placeholder="请输入"v-model.number="f.number"></el-input>
                                            </el-form-item>

                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="oneLName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.oneLName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqun" v-if="this.isFx">
                                                <el-select @change="getLianqun" v-model="f.lianqun" placeholder="请选择" >
                                                    <el-option v-for="item in lianqunList" :key="item.lianqunCode"
                                                               :label="item.lianqunName" :value="item.lianqunCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="责任部门" class="h-elformWrap-2" prop="fxDeptFaqi" v-if="this.isFx">
                                                <el-select filterable  v-model="f.fxDeptZeren" @change="changeFxType" placeholder="请选择">
                                                    <el-option value="1" label="各链群"></el-option>
                                                    <el-option value="2" label="开发平台"></el-option>
                                                    <el-option value="3" label="制造中心"></el-option>
                                                    <el-option value="4" label="SQE"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="发起部门" class="h-elformWrap-2" prop="fxDeptFaqi" v-if="this.isFx">
                                                <el-select @change="getLianqun" v-model="f.lianqun" placeholder="请选择" >
                                                    <el-option v-for="item in lianqunList" :key="item.lianqunCode"
                                                               :label="item.lianqunName" :value="item.lianqunCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item label="时间" class="h-elformWrap-2"  prop="fxDate" v-if="this.isFx">
                                                <el-date-picker type="date" placeholder="选择时间" value-format="yyyy-MM-dd" v-model="f.fxDate"
                                                                ></el-date-picker>
                                            </el-form-item>

                                           <!-- :picker-options="pickerOptions"-->
                                            <el-form-item label="备注" class="h-elformWrap-2" prop="remark">
                                                <el-input  v-model="f.remark" ></el-input>
                                            </el-form-item>

                                            <el-form-item label="问题描述" class="h-elformWrap-3" prop="fxProblem" v-if="this.isFx">
                                                <el-input type="textarea" v-model="f.fxProblem" :clearable="true" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="原因" class="h-elformWrap-3" prop="fxReason" v-if="this.isFx">
                                                <el-input type="textarea" v-model="f.fxReason" :clearable="true" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="处理措施" class="h-elformWrap-3" prop="fxMeasure" v-if="this.isFx">
                                                <el-input type="textarea" v-model="f.fxMeasure" :clearable="true"></el-input>
                                            </el-form-item>
                                            <br>
                                            <el-form-item label="上传评审单" prop="fxPsd" class="h-elformWrap-2" v-if="this.isFx">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="返修-评审单"
                                                        uploadflag
                                                        delflag
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>

                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>样机确认</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" >
                                                <el-select  @change="handleItemChange1" v-model="f.reformEdition" placeholder="请选择">
                                                    <el-option
                                                            v-for="item in reformEditionList"
                                                            :key="item.VERID"
                                                            :label="item.VERID +'-'+ item.TEXT1"
                                                            :value="item.VERID">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="GEMS立项号" class="h-elformWrap-2" prop="plnnrId" v-if="!this.isFx">
                                                <el-input  v-model="f.plnnrId" ></el-input>
                                            </el-form-item>
                                          <!--  <el-form-item label="成本中心" class="h-elformWrap-2" prop="costCenter" v-if="!this.isFx">
                                                <brselect category="yj_cost_center" :v="f.costCenter" v-model="f.costCenter"
                                                          :clearable="true"
                                                          style="width:100%"/>
                                            </el-form-item>-->
                                            <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                <el-checkbox-group v-model="f.stationlist" >
                                                    <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="f.checkRequest"></el-input>
                                            </el-form-item>
                                            <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="改制明细测试报告"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>


                                </div>
                                <el-button
                                        class="h-btn h-formBtn h-bgblueQ"
                                        icon="h-el-icon h-el-icon-export"
                                        style="margin:20px"
                                        v-if="!this.isFx"
                                        @click="uploaddownexcelflagbtn"
                                >
                                    改制物料明细导入
                                </el-button>
                                <uploaddownexcel
                                        :visible.sync="uploaddownexcelflag"
                                        v-if="uploaddownexcelflag"
                                        clsname="reformMainProDetailImportExcel"
                                        :startrow="2"
                                        :extparams="{id:f.id,number:f.number,MATNR:f.materialCode,WERKS:this.factory}"
                                        @callback="uploadExcelFilecallback"/>
                                <span style="color: red;font-size: 12px;display: inline-block;padding-left: 20px;">改制过程中，不允许增加或者删除总成，可以在总成下增加、删除、替换物料删除总成物料时注意：总成下的物料不允许全部删除，至少保留一个物料</span>
                                <el-table
                                        ref="multipleTable"
                                        :data="f.reformMainPrototypeDetailList"
                                        border
                                        v-if="!this.isFx"
                                        max-height="500"
                                        style="width: 100%">
                                    <el-table-column label="个性化改制物料明细">

                                        <el-table-column
                                                prop="stuf"
                                                label="层级"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.stuf" ></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="materialName"
                                                label="物料描述"
                                                width="180">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialName" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCode"
                                                label="物料专用号"
                                                width="140">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialCode" @change="getSupplier(scope.row)" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="sobsl"
                                                label="是否虚拟件"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.sobsl" ></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="purchaseGroup"
                                                label="采购组"
                                                width="110">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.purchaseGroup" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialOrder"
                                                label="物料单耗"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialOrder" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unit"
                                                label="单位"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unit" placeholder="单位"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="number"
                                                label="数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.number" placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="supplierName"
                                                label="供应商名称"
                                                width="150">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.supplierName" placeholder="供应商名称"> </el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="remark"
                                                label="备注"
                                                width="100">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.remark" placeholder="备注"> </el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="changeBs"
                                                label="新增/删除"
                                                width="120">
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.changeBs" :clearable="true">
                                                    <el-option label="新增" value="新增"></el-option>
                                                    <el-option label="删除" value="删除"></el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>
                              <!--      <el-table-column label="原版物料对照">
                                        <el-table-column
                                                prop="stufold"
                                                label="层级"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.stufold" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialNameOld"
                                                label="物料描述"
                                                width="180">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialNameOld" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCodeOld"
                                                label="物料专用号"
                                                width="140">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialCodeOld" @change="getSupplier(scope.row)" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="purchaseGroupOld"
                                                label="采购组"
                                                width="110">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.purchaseGroupOld" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialOrderOld"
                                                label="物料单耗"
                                                width="100">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialOrderOld" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="sobslold"
                                                label="是否虚拟件"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.sobslold" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unitOld"
                                                label="单位"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unitOld" placeholder="单位"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numberOld"
                                                label="数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numberOld" placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="supplierNameOld"
                                                label="供应商名称"
                                                width="150">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.supplierNameOld" placeholder="供应商名称"> </el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="remarkOld"
                                                label="备注"
                                                width="100">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.remarkOld" placeholder="备注"> </el-input>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>-->
                                    <el-table-column
                                            label="操作"
                                            fixed="right"
                                            width="80">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" v-if="true" @click="delIndex(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="h-tableAdd" @click="adds" v-if="!this.isFx">
                                    <a>新增一行</a>
                                </div>
                            </div>


                        </el-form>

                    </div>
                </div>
            </div>
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="f.instid"/>
            <!--选择物料-->
            <shouwuliao
                    :visible.sync="xuanwuliao"
                    v-if="xuanwuliao"
                    @choseObj="chanpinxinghaochangetype"
                    :usercode="f.agentCode"
                    oneflag
                    title="选择物料" />
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="saveS('暂存')">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS('提交')">确认提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import reformService from "../../../api/reform/reformService.js";
    import uploaddownexcel from "../../../components/uploaddown/uploaddownbomexcel";
    import ss from "../../../api/SystemService";
    import shouwuliao from '../../../components/dialog/nxwl-ref'
    import specificCatalogue from "../../../api/reform/specificCatalogue";

    export default {
        components: {
            uploaddownexcel,
            shouwuliao
        },

        data() {
            return {
                showhistory:false,


                //全部物料工位
                options: [],
                //生产版本list
                reformEditionList:{},

                //导入Excel
                uploaddownexcelflag: false,
                //可选链群
                lianqunList:[],

                //是否可以选择时间
                startDateLimit: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() + 7 * 24 * 3600 * 1000
                    }
                },
                factory:null,
                isFx:false,
                xuanwuliao:false,
                //带线表单
                f: {
                    reformType:null,
                    id:null,
                    submitflag:null,
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量4
                    plnnrId:null,//立项号
                    costCenter:null,//成本中心
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    produceTime:null, // 生产日期
                    instid:null,
                    reformId:null, // 定制编号
                    reformType:'',//0生产改制1库存改制
                    reformEdition:'',//生产版本
                    typeUserCode:null,//型号经理编码
                    typeUserName:null,//型号经理名称
                    materialStation:null,//物料工位
                    individualizeReform:null,//个性化定制标准描述
                    logoRequest:null,//包装标识要求
                    changeRequest:null,

                    fxType:null,
                    fxDeptFaqi:null,
                    fxDeptZeren:null,
                    fxProblem:null,
                    fxReason:null,
                    fxMeasure:null,
                    fxDate:null,
                    //物料明细
                    reformMainPrototypeDetailList: [{materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                        materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',id:this.$util.getUuid(),
                        supplierName:'',supplierNameTh:'',changeDes:'',purchaseGroup:'',
                        materialNameOld:null,
                        materialCodeOld:null,
                        purchaseGroupOld:null,
                        materialOrderOld:null,
                        unitOld:null,
                        numberOld:null,
                        supplierNameOld:null,
                        remarkOld:null,
                        stuf:null,
                        stufold:null,
                        sobsl:null,
                        sobslold:null,
                        changeBs:null,
                        pMaterialCode:null,
                    }],

                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],

                    remark:null,//备注
                    //选择的物料工位
                    stationlist:[],
                    //审批相关参数
                    taskid:null,
                    optflag:null,
                    shpyj:null,
                },


                rules: {
                    reformId:[{required: true, message: '需求号必填', trigger: 'change'}],
                    agentCode: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    areaName: [{required: true, message: '请选择区域', trigger: 'change'}],
                    lianqunName: [{required: true, message: '请选择链群', trigger: 'change'}],
                    materialCode: [{required: true, message: '请选择物料', trigger: 'change'}],
                    materialName: [{required: true, message: '请选择物料', trigger: 'change'}],
                    number: [{required: true, message: '请填写数量', trigger: 'change'}],
                    produceTime:[{required: true, message: '请选择生产日期', trigger: 'change'}],
                    oneLName: [{required: true, message: '请填产品大类', trigger: 'change'}],
                    typeUserCode: [{required: true, message: '请填写型号经理工号', trigger: 'change'}],
                    reformType: [{required: true, message: '请选择改制类型', trigger: 'blur'}],
                    stationlist: [{type: 'array', required: true, message: '请至少选择一个物料工位', trigger: 'change'}],

                    fxType: [{required: true, message: '请填返修类型', trigger: 'change'}],
                    fxDeptFaqi: [{required: true, message: '请填发起部门', trigger: 'change'}],
                    fxDate: [{required: true, message: '请填时间', trigger: 'change'}],
                    fxMeasure: [{required: true, message: '请填处理措施', trigger: 'blur'}],
                    fxProblem: [{required: true, message: '请填处理措施', trigger: 'blur'}],
                    fxReason: [{required: true, message: '请填原因', trigger: 'blur'}],

                    plnnrId: [{required: true, message: '请填GEMS立项号', trigger: 'blur'}],
                    remark: [{required: true, message: '请填写备注', trigger: 'blur'}],
                    costCenter: [{required: true, message: '请填成本中心', trigger: 'blur'}],

                },
            }
        },
        created() {
            this.f.taskid = this.$route.query.taskid;
            this.f.id = this.$route.query.ywid || this.$util.getUuid();

            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");
            this.query(this.f.id);
        },
        methods: {

            query(id) {
                reformService.selectProById(id).then(rd => {

                    this.f = {...this.f,...rd.obj};
                    this.f.matecode = this.f.materialCode;
                    this.getReformEdition(this.f);
                })
            },

            //返回
            backS() {
                this.$router.push({path: "/chanp/reformPrototypeList"});
            },
            viewpress(r){
                this.showhistory = true;
            },
            //驳回
            auditFail() {

                this.f.optflag = '驳回'
                if(!this.f.shpyj){
                    this.$msg.msge("驳回必须输入审批意见！");
                    return;
                }
                this.$msg.confirm("确认提交？", () => {
                    this.submitForm();
                })

            },
            //获取生产版本
            getReformEdition(val) {
                this.reformEditionList = []
                /*this.reformEditionList = [{
                    VERID:7788,
                    TEXT1:'测试',

                },{
                    VERID:7789,
                    TEXT1:'测试1',

                }]*/

                let promises = []; // 创建一个存储异步操作的Promise数组
                //根据所选物料获取产地
                let promise = ss.salesList.selectModel(val.matecode).then(rd => {
                    if(rd.factory != null && rd.factory !=''){
                        this.factory = rd.factory;
                    }
                })
                //根据所选物料获取产地
                let promise1 = ss.declaration.selectModel(val.matecode).then(rd => {
                    if(rd.factory != null && rd.factory !=''){
                        this.factory = rd.factory;
                    }
                })
                promises.push(promise); // 将每个异步操作的Promise添加到数组中
                promises.push(promise1); // 将每个异步操作的Promise添加到数组中
                Promise.all(promises) // 等待所有异步操作完成
                    .then(() => {
                        var data = {
                            WERKS: this.factory,
                            MATNR: this.f.materialCode,
                            reformType: "Y",
                        }
                        reformService.getSapReformEditionUtil(data).then(rd => {
                            console.log("rd",rd);
                            this.reformEditionList = rd.msg;
                        })
                    });
            },
            handleItemChange1(value){
                console.log(value)
                this.f.reformEdition = value;
            },
            //提交
            saveS(submitflag) {
                this.f.submitflag = submitflag;
                //如果有流程id则认为是重新提交
                if (this.f.submitflag=='提交' && this.f.instid) {
                    this.f.submitflag = '重新提报'
                }
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                console.log("this.factory",this.factory)
                if(this.factory == '9370' && (
                    this.f.stationlist.includes("2001") || this.f.stationlist.includes("2000") ||
                    this.f.stationlist.includes("2002") || this.f.stationlist.includes("2003")
                ) ){
                    this.$msg.msge("产地为9370的物料库位只可选择7200或7201！");
                    return;
                }
                if(this.factory == '9393' && (this.f.stationlist.includes("7201") || this.f.stationlist.includes("7200")) ){
                    this.$msg.msge("产地为9393的物料库位只可选择2000或2001或2002或2003！");
                    return;
                }

                if (subflag == true) {
                    this.f.optflag = '通过'
                    this.$msg.confirm("确认提交？", () => {

                        this.f.materialStation = this.f.stationlist.join(",");

                        this.f.individualizeReform = this.f.individualizeList.join("##");
                        this.f.logoRequest = this.f.logoRequestList.join("##");

                        this.submitForm();
                    })
                }
            },
            submitForm() {

                reformService.xinghaojlTj(this.f).then(rd => {
                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回原页面
                        this.$router.go(-1);
                    })
                })
            },

            zancun(){
                if(this.f.stationlist){
                    this.f.materialStation = this.f.stationlist.join(",");
                }
                if(this.f.individualizeList){
                    this.f.individualizeReform = this.f.individualizeList.join("##");
                }
                if(this.f.logoRequestList){
                    this.f.logoRequest = this.f.logoRequestList.join("##");
                }

                reformService.xhZancunPrototype(this.f).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
            },

            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.f.reformMainPrototypeDetailList = rd.obj;
                //自动计算数量  = 产品数量*单耗
                this.f.reformMainPrototypeDetailList.forEach((item, index) => {
                    //如果入了单耗不为空 但是数量是空就自动计算
                    if(item.materialOrder && !item.number){
                        item.number = item.materialOrder * this.f.number;
                    }
                })

            },
            //根据根据编码查询物料信息
            selectListByCode(code) {
                //弹出物料选择框
                this.xuanwuliao = true;
            },
            changeFxType(){


            },
            //选择产品型号的方法
            chanpinxinghaochangetype(val) {
                console.log(val);
                //大类名称及编码
                this.f.oneLId = val.cpdlcode;
                this.f.oneLName = val.cpdlname;
                //产品编码及名称
                this.f.materialCode = val.matecode;
                this.f.materialName = val.matedes;
                this.f.typeUserCode = val.typeUserCode;
                this.xuanwuliao = false;
                //获取生产版本
                this.getReformEdition(val);
                //获取链群
            },

            //增加行
            adds(){
                var a = {
                    materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                    materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',purchaseGroup:'',
                    fileId:this.$util.getUuid(),id:this.$util.getUuid(),supplierName:'',supplierNameTh:'',changeDes:''
                    ,stuf:'',stufold:'',sobsl:'',sobslold:'',changeBs:'',pMaterialCode:''
                };
                this.f.reformMainPrototypeDetailList.push(a)
            },

            //删除一行
            delIndex(index){
                this.f.reformMainPrototypeDetailList.splice(index, 1)
            },

            //增加一行个性化描述
            addIndividualize() {
                this.f.individualizeList.push('')
            },
            //减少一行性化描述
            deleteIndividualize(index) {
                this.f.individualizeList.splice(index, 1)
            },
            changeReformType(value){

                if(value == 1){
                    this.isFx = true;
                    this.f.reformMainPrototypeDetailList = [];
                }else {
                    this.isFx = false;
                }

            },
            //增加一行标识要求
            addLogoRequest() {
                this.f.logoRequestList.push('')
            },
            //减少一行标识要求
            deleteLogoRequest(index) {
                this.f.logoRequestList.splice(index, 1)
            },
            getSupplier(v){
                reformService.getSupplier(v.materialCode).then( rd =>{
                    v.supplierName = rd.msg.supplierName;
                })
                reformService.getPurchaseGroup(v.materialCode).then( rd =>{
                    v.purchaseGroup = rd.msg.purchaseGroupCode;
                })
            },
            getSupplierTh(v){
                reformService.getSupplier(v.materialCodeTh).then( rd =>{
                    v.supplierNameTh = rd.msg.supplierName;
                })
            },

        }
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }


    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
